// extracted by mini-css-extract-plugin
export default {"formContainer":"s2Y7lT"};